"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Breadcrumbs = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _NavigateNextRounded = _interopRequireDefault(require("@material-ui/icons/NavigateNextRounded"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Breadcrumbs = _ref => {
  let {
    children,
    className,
    color
  } = _ref;
  const useStyles = (0, _core.makeStyles)(theme => ({
    item: {
      color: theme.palette.text.secondary,
      cursor: 'pointer'
    }
  }));
  const classes = useStyles();
  /**
   * Componente primário de interação com o usuário
   */
  return /*#__PURE__*/_react.default.createElement(_core.Breadcrumbs, {
    className: className,
    separator: /*#__PURE__*/_react.default.createElement(_NavigateNextRounded.default, {
      fontSize: "small"
    })
  }, children.map((link, key) => {
    if (key === children.length - 1) return /*#__PURE__*/_react.default.createElement(_core.Typography, {
      key: link.label,
      color: color
    }, link.label);
    return /*#__PURE__*/_react.default.createElement(_core.Link, {
      key: link.label,
      className: classes.item,
      href: link.href,
      onClick: link.onClick
    }, link.label);
  }));
};
exports.Breadcrumbs = Breadcrumbs;
Breadcrumbs.propTypes = {
  /**
   * Conteúdo do Breadcrump
   */
  children: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  /**
   * Classe css para o botão
   */
  className: _propTypes.default.string,
  /**
   * Cor do botão
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired
};
Breadcrumbs.defaultProps = {
  className: null
};
var _default = exports.default = Breadcrumbs;